export default {"src":"/frontend-static/_next/static/media/heart-outline.81b9be51.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};